<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-image-filter-center-focus</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.icons') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/> -->
    </v-toolbar>
    <select-image
      v-show="!collapseContent"
      v-model="content.IconsURL"
      :isFullWidth="true"
      :enterpriseID="enterpriseID"
      :imageOld='content.IconsURL'
      @input="handleChangeIsModified"
      style="margin-left:0px;margin-top:15px;margin-right: 0px;"
      width="100px"
    />
    <br />
    <v-btn-toggle v-model="content.IconsAlign" >
        <v-btn value="left">
          <v-icon>mdi-format-align-left</v-icon>
        </v-btn>

        <v-btn value="center">
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>

        <v-btn value="right">
          <v-icon>mdi-format-align-right</v-icon>
        </v-btn>
      </v-btn-toggle>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import SelectImage from '@/components/SelectImage'
  export default {
    components: {
      SelectImage
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      }
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

